export const ERROR_OBTIENE_TOKEN_AUTENTICACION = 'Error al autenticar'
export const ERROR_OBTENER_OFERTA_DIGITAL = 'Error al obtener oferta digital'
export const ERROR_OBTENER_DATOS_PERSONA =
  'Error al obtener datos de la persona'
export const ERROR_OBTENER_FRECUENCIA_PLAZO_PRODUCTO =
  'Error al obtener frecuencia y plazo del producto'
export const ERROR_OBTENER_PAGO_SIMULADO = 'Error al obtener datos del crédito'
export const ERROR_INSERTAR_DOCUMENTOS = 'Error guardar documentos de solicitud'
export const ERROR_ACTUALIZA_ESTATUS_SOLICITUD = 'Error actualizar la solicitud'
